import {Inject, LOCALE_ID, Pipe, PipeTransform} from '@angular/core';
import {Locale} from '@emma-labs/shared/typescript';

interface Translate<T> {
  en: T;
  fr: T;
}

@Pipe({
  name: 'emTranslate',
})
export class EmTranslatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private locale: Locale) {}

  transform<T>(value: Translate<T>, ...args: any[]): T {
    if (args.some((x) => x === 'en')) {
      return value.en;
    } else if (args.some((x) => x === 'fr')) {
      return value.fr;
    } else if (this.locale === 'fr-CA') {
      return value.fr;
    } else {
      return value.en;
    }
  }
}
